export default __webpack_public_path__ + "static/media/people-talk.f470f7c8.jpg";